import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { setProcessing } from "@store/avatarSlice";

const DEBOUNCE_TIMEOUT = 500;

export const useDebounceProcessing = (): {
  setValue: (
    value: boolean,
    setImmediate: boolean,
    debounceTime?: number,
  ) => void;
} => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const dispatch = useDispatch();

  const setValue = useCallback(
    (
      value: boolean,
      setImmediate: boolean,
      debounceTime = DEBOUNCE_TIMEOUT,
    ) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (setImmediate) {
        dispatch(setProcessing(value));
      } else {
        timeoutRef.current = setTimeout(() => {
          dispatch(setProcessing(value));
        }, debounceTime);
      }
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    },
    [dispatch],
  );

  return {
    setValue,
  };
};
